export const PATHS = {
  ROOT: '/',
  STATUS: '/status',
  ROUTES: '/routes',
  ROUTES_DETAILS: '/routes/:routeId/details',
  ROUTES_EDIT: '/routes/:routeId/edit',
  HOLDINGS: '/holdings',
  CATALOG: '/catalog',
  ORDERS: '/orders',
  ORDERS_DETAIL: '/orders/:orderId',
  SUPPORT: '/support',
  UPDATES: '/updates',
  TRANSFERS: '/transfers',
  ACTIVITY: '/activity',
  BASKET: '/basket',
  SETTINGS: '/settings',
} as const;
